import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";

import { RoutesSlugs } from "@app/routes-slugs";

export const isNativeGuard: CanActivateFn = () => {
  return Capacitor.isNativePlatform()
    ? true
    : inject(Router).createUrlTree([RoutesSlugs.HOME]);
};
